import React, { FC } from 'react';
import classNames from 'classnames';
import { Hyperlink } from '../../../../../components/Hyperlink';
import styles from './animated_link.module.scss';

type Props = React.HTMLProps<HTMLAnchorElement>;

export const SearchAnimatedLink: FC<Props> = ({ children, ...rest }) => (
  <Hyperlink className={styles.link} {...rest}>
    <span className={styles.label}>{children}</span>
    <i
      className={classNames(
        'material-icons',
        'icons__arrow_forward',
        styles.icon,
      )}
    />
  </Hyperlink>
);
